import { useCallback, useSyncExternalStore } from "react";

const STORAGE_KEY = "runcards_console_pace_unit";

let unitState = "mi";
const listeners = new Set();

function readStoredUnit() {
  if (typeof window === "undefined") return "mi";
  try {
    const v = window.localStorage.getItem(STORAGE_KEY);
    return v === "km" ? "km" : "mi";
  } catch {
    return "mi";
  }
}

if (typeof window !== "undefined") {
  unitState = readStoredUnit();
}

function getSnapshot() {
  return unitState;
}

function subscribe(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

function emit() {
  listeners.forEach((l) => l());
}

export function setConsolePaceUnit(unit) {
  const next = unit === "km" ? "km" : "mi";
  if (next === unitState) return;
  unitState = next;
  try {
    if (typeof window !== "undefined") {
      window.localStorage.setItem(STORAGE_KEY, next);
    }
  } catch {
    /* ignore quota / private mode */
  }
  emit();
}

/** @returns {'mi' | 'km'} */
export function getConsolePaceUnit() {
  return unitState;
}

/**
 * Shared pace unit for admin console club/run forms. Persists in localStorage
 * so all pace pickers stay in sync.
 */
export function useConsolePaceUnit() {
  const unit = useSyncExternalStore(subscribe, getSnapshot, () => "mi");
  const setUnit = useCallback((u) => {
    setConsolePaceUnit(u);
  }, []);
  return { unit, setUnit };
}
